
import { useState, useCallback } from 'react';
import type {
    SmartCopywritingProject,
    TargetAudience,
    UsageScenario,
    GenerateCopyResult,
    CopywritingStep,
} from '../types';

export interface UseSmartCopywritingState {
    project: SmartCopywritingProject | null;
    productName: string;
    audiences: TargetAudience[];
    scenarios: UsageScenario[];
    copyResult: GenerateCopyResult | null;
    currentStep: CopywritingStep;
    loading: {
        project: boolean;
        audiences: boolean;
        scenarios: boolean;
        generation: boolean;
        saving: boolean;
    };
}

export const useSmartCopywritingState = () => {
    const [state, setState] = useState<UseSmartCopywritingState>({
        project: null,
        productName: '',
        audiences: [],
        scenarios: [],
        copyResult: null,
        currentStep: 1,
        loading: {
            project: false,
            audiences: false,
            scenarios: false,
            generation: false,
            saving: false,
        },
    });

    const setLoading = useCallback((key: keyof typeof state.loading, value: boolean) => {
        setState(prev => ({
            ...prev,
            loading: { ...prev.loading, [key]: value }
        }));
    }, []);

    return { state, setState, setLoading };
};
